var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgProcessingIcon = function SvgProcessingIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0C12.9845 0 0 12.9845 0 29C0 45.0155 12.9845 58 29 58C45.0155 58 58 45.0155 58 29C58 12.9845 45.0155 0 29 0ZM42.3846 33.4615H29C28.4084 33.4615 27.841 33.2265 27.4226 32.8082C27.0043 32.3898 26.7692 31.8224 26.7692 31.2308V11.1538C26.7692 10.5622 27.0043 9.9948 27.4226 9.57645C27.841 9.1581 28.4084 8.92308 29 8.92308C29.5916 8.92308 30.159 9.1581 30.5774 9.57645C30.9957 9.9948 31.2308 10.5622 31.2308 11.1538V29H42.3846C42.9762 29 43.5437 29.235 43.962 29.6534C44.3804 30.0717 44.6154 30.6391 44.6154 31.2308C44.6154 31.8224 44.3804 32.3898 43.962 32.8082C43.5437 33.2265 42.9762 33.4615 42.3846 33.4615Z",
    fill: "#6F719B"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgProcessingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/processing_icon.f7a385617b286868b66eb47669e8d829.svg";